import React from "react";
import { useWatch } from "react-hook-form";

import { StyledWrapper } from "./rewardPolicyField.style";

import RadioField from "../../../../formComponents/formFields/radioField/radioField.component";

import ExternalReward from "./nestedPolicies/externalReward.component";
import WinRuHm from "./nestedPolicies/winRuHm.component";
import Percentile from "./nestedPolicies/percentile.component";

const RewardPolicyField = ({ name, required, settings = {}, options = [] }) => {
  const watchedPolicy = useWatch({ name });
  const option = options.find((item) => item.value === watchedPolicy);
  return (
    <StyledWrapper>
      <RadioField
        name={name}
        required={required}
        settings={settings}
        options={options}
      />
      {watchedPolicy === "external_reward" && (
        <ExternalReward options={option} />
      )}
      {watchedPolicy === "percentile_" && <Percentile options={option} />}
      {["win_hm", "win_ru_hm"].includes(watchedPolicy) && (
        <WinRuHm options={option} />
      )}
    </StyledWrapper>
  );
};

export default RewardPolicyField;
